import { CommonGameEvent } from "@lib/titan2/dist/game/controller/event/CommonGameEvent";
import { AbstractOptionsMenu } from "@lib/titan2/dist/game/view/display/AbstractOptionsMenu";
import { Service } from "../../../../api/Service";
/**
 * Options.ts
 */
export class Options extends AbstractOptionsMenu {
    createButtons() {
        super.createButtons();
    }
    handleSFXButtonSelected() {
        let event = this.sfxButton.isSelected() ? CommonGameEvent.SFX_OFF : CommonGameEvent.SFX_ON;
        this.model.dispatchKPI("TITAN_STATE", this.sfxButton.isSelected() ? "GAME_SOUND_EFFECTS_OFF_INTERNAL" : "GAME_SOUND_EFFECTS_ON_INTERNAL", null);
        this.model.dispatch(event);
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(CommonGameEvent.STANDARD_SPIN_RECOVERY, this.handleRecovery);
        this.registerGame(CommonGameEvent.FREE_SPIN_RECOVERY, this.handleRecovery);
        this.registerGame(CommonGameEvent.PURCHASE_SPIN_RECOVERY, this.handleRecovery);
    }
    handleIdle() {
        if (!Service.isReplay()) {
            this.enable();
        }
    }
    handleResize(event) {
    }
    handleRotate(event) {
        super.handleRotate(event);
        this.uiProperties = this.uiProperties;
    }
}
//# sourceMappingURL=Options.js.map